import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store/index';

// Import Components
import login from '@/components/login/login.vue';
import registerPage from '@/components/registerPage/registerPage.vue';
import emailDashboard from '@/components/emailDashboard/emailDashboard.vue';
import inboxTable from '@/components/inboxDetails/inboxTable.vue';
import mixedChart from '@/pages/chart/mixedChart.vue';
// import userDetails from '@/components/userTable/userDetails.vue';
import addUserDetail from '@/components/userTable/addUserDetails/addUserDetail.vue';
import editUserDetails from '@/components/userTable/editDetails/editUserDetail.vue';
import forgotPassword from '@/components/forgotPassword/forgotPassword.vue';
import searchAutoFill from '@/components/searchAutoFill/searchAutoFill.vue';
import emailReport from '@/components/emailReport/emailReport.vue';
import termCondition from '@/components/termCondition/termCondition.vue';
import lineChart from '@/pages/chart/lineChart.vue';
import addDomain from '@/components/settings/addDomain.vue';

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', name: 'login-page', component: login, meta: { hideSidebar: true } },
  { path: '/registerPage', name: 'register-page', component: registerPage, meta: { hideSidebar: true } },
  { path: '/forgotPassword', name: 'forgot-password', component: forgotPassword, meta: { hideSidebar: true } },
  { path: '/termCondition', name: 'term-condition', component: termCondition, meta: { hideSidebar: true } },
  { path: '/emailDashboard', name: 'email-dashboard', component: emailDashboard, meta: { requiresAuth: true } },
  { path: '/emailReport', name: 'email-report', component: emailReport, meta: { requiresAuth: true } },
  { path: '/inboxTable', name: 'inbox-table', component: inboxTable, meta: { requiresAuth: true } },
  { path: '/addUserDetail', name: 'add-user-detail', component: addUserDetail, meta: { requiresAuth: true }},
  { path: '/editUserDetail', name: 'edit-user-detail', component: editUserDetails, meta: { requiresAuth: true }},
  // { path: '/userDetails', name: 'user-details', component: userDetails, meta: { requiresAuth: true }},
  { path: '/mixedChart', name: 'mix-chart', component: mixedChart, meta: { requiresAuth: true } },
  { path: '/lineChart', name: 'line-chart', component: lineChart, meta: { requiresAuth: true } },
  {path: '/addDomain' , name: 'add-domain', component: addDomain, meta: { requiresAuth: true}},
  { path: '/searchAutoFill', name: 'search-auto-fill', component: searchAutoFill },
  { path: '/:pathMatch(.*)*', redirect: '/login' },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.isAuthenticated;
  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: "login-page" });
  } else {
    next();
  }
});

export default router;